import { render, staticRenderFns } from "./ModalFakeUser.vue?vue&type=template&id=0248e0c6&"
import script from "./ModalFakeUser.vue?vue&type=script&lang=js&"
export * from "./ModalFakeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports